import React from "react";
import { api } from "../../api/config";
import { RecordContextType } from "../../components/record/Record";
import { getStore } from "../../store/store";
import { UserFromAPI } from "../../types/auth.types";
import { NoInstrumentsConfirmDialog } from "./components/NoInstrumentsConfirmDialog";

export const actions = [
	/*
	TODO: I comented on 15/06/26 in case if needed on the future
	Probably it wont be, so safe to delete in 2 months time
    {
        code: "create_pdf_report_legacy",
        name: "Criar PDF da avaliação",
        actionFn: (context: any, executeAction: any) => openEvaluationDialog(context, true),
    },
 */
        {
        code: "create_pdf_report",
        name: "Criar PDF da avaliação",
        actionFn: (context: any, executeAction: any) => openEvaluationDialog(context, false),
    },
    {
        code: "create_pdf_report_instruments",
        name: "Criar PDF da avaliação (instrumentos novo)",
        actionFn: (context: any, executeAction: any) => openEvaluationDialog(context, false, true),
    },
    {
        code: "send_evaluation_to_client",
        name: "Enviar avaliação / EEG  para cliente",
        actionFn: (context: RecordContextType, code: string, user: UserFromAPI) => sendEvaluationToClient(context, code, user),
    },
];

const sendEvaluationToClient = async (context: RecordContextType, code: string, user: UserFromAPI) => {
    const confirmed = window.confirm("De certeza que deseja enviar esta avaliação para o cliente?");
    const { notifications } = getStore();

    if (!confirmed) return;

    try{
        await api({
            method: "POST",
            url: "https://hook.eu1.make.com/4xhf89f57d3y2atetehn1t1pccs1dwrz",
            data: {
                item: context.item.id,
                userId: user.id,
                action: code,
            },
        });
        notifications.setNotification({
            isOpen: true,
            message: "Avaliação enviada para o cliente",
            severity: "success",
        })
    } catch (error: any) {
        notifications.setNotification({
            isOpen: true,
            message: error.response.data,
            severity: "error",
        });
    }
};

const openEvaluationDialog = (context: RecordContextType, isLegacy: boolean, isInstrumentsVersion = false) => {
    try {
        const { evaluation_report_dialog, appDialog } = getStore();

        const openReport = () => {
            evaluation_report_dialog.setIsLegacy(isLegacy);
            evaluation_report_dialog.setIsInstrumentsVersion(isInstrumentsVersion);
            evaluation_report_dialog.setIsOpen(true);
            evaluation_report_dialog.setContext(context);
        };

        const hasInstrumentsSelected = (context.item?.instrument_responses?.length ?? 0) > 0;
        if (isInstrumentsVersion && !hasInstrumentsSelected) {
            appDialog.createDialog({
                title: "Sem instrumentos selecionados",
                contentAndActions: React.createElement(NoInstrumentsConfirmDialog, {
                    onCancel: () => appDialog.toggleIsOpen(),
                    onConfirm: () => {
                        appDialog.toggleIsOpen();
                        openReport();
                    },
                }),
                allowSoftCancel: true,
            });
            return { showSuccessMessage: "no" };
        }

        openReport();

        return {
            showSuccessMessage: "no",
        };
    } catch (error: any) {
        console.log(error);
        throw new Error("algo correu mal");
    }
};
